import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { Content } from './ui/Content'

export class FlowDeleteActionStore {
  constructor(private deleteAction: (isNextDelete: boolean) => void, isBranchDelete?: boolean) {
    if (isBranchDelete) {
      this._openBranchDeleteModal()
    } else {
      this._openModal()
    }

    makeAutoObservable(this)
  }
  id = nanoid()

  private _openModal = () => {
    modalStore.addModal({
      id: this.id,
      title: 'Delete',
      ModalContent: () => <Content store={this} />,
      pureContent: true,
    })
  }

  private _openBranchDeleteModal = () => {
    modalStore.addModal({
      id: this.id,
      type: ModalTypeList.ALERT,
      title: 'Delete branch?',
      desc: 'Deleting the If/Else block will also remove all actions that follow it. Make sure to review and back up any important steps before continuing.',
      primaryAction: {
        text: 'Yes, delete',
        onAction: () => {
          this.deleteAction(true)
          modalStore.closeModal(this.id)
        },
      },
      closeActionButtonProps: {
        title: 'Cancel',
        contained: 'secondary',
      },
    })
  }

  onClose = () => {
    modalStore.closeModal(this.id)
  }

  onDelete = () => {
    this.deleteAction(this.isNextDelete)
    this.onClose()
  }

  isNextDelete = false
  setNextDelete = (value: boolean) => {
    this.isNextDelete = value
  }
}
